RivalIQ.apps.Insights.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const config = [
        {
            name: 'top',
            sizes: {
                md: 12
            },
            page: 0
        },
        [
            {
                name: 'middle-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            },
            {
                name: 'middle-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            }
        ],
        {
            name: 'bottom',
            sizes: {
                md: 12
            },
            page: 1
        }
    ];

    const Dashboard = RivalIQ.apps.Dashboard;
    const widgetTypes = RivalIQ.enums.widgetTypes;

    const widgets = [
        {
            instanceId: 'additional-auth-twitter',
            widgetId: RivalIQ.enums.widgetTypes.ADDITIONAL_AUTHORIZATION,
            region: 'top',
            supportedExportFormats: [],
            props: {
                source: RivalIQ.enums.sources.TWITTER_INSIGHTS
            }
        },
        {
            instanceId: 'followers',
            widgetId: widgetTypes.TWITTER_INSIGHTS_FOLLOWERS,
            region: 'middle-left',
            props: {
                title: 'Followers',
                useUniversalMetricsApi: true,
                source: RivalIQ.enums.sources.TWITTER, // Though this is twitter insights, we're showing public twitter metrics here.
                metrics: [
                    {
                        channel: RivalIQ.enums.channels.TWITTER,
                        description: RivalIQ.strings.twitter_insights_followers_count_description,
                        property: 'audience',
                        dimensions: ['timeAnalysisMode', 'companyId', 'channel'],
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                        metricType: RivalIQ.enums.metricType.TOTAL,
                        useIntervalDomainFormatting: true
                    }
                ]
            }
        },
        {
            instanceId: 'overview',
            widgetId: widgetTypes.INSIGHTS_PROFILE_OVERVIEW,
            region: 'middle-right',
            props: {
                channel: RivalIQ.enums.channels.TWITTER,
                source: RivalIQ.enums.sources.TWITTER, // Though this is twitter insights, we're showing public twitter metrics here.
                useUniversalMetricsApi: true,
                metrics: [
                    {
                        dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                        property: 'following_insights',
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                    },
                    {
                        dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                        property: 'followers_to_following_insights',
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                    },
                    {
                        dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                        property: 'listed_count',
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                    },
                    {
                        dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                        property: 'lifetime_count_insights',
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                    },
                    {
                        dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                        property: 'lifetime_likes',
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                    }
                ]
            }
        }
    ];

    const TwitterInsightsLayout = Dashboard.views.CurationLayout.extend({
        config: config,
        template: '#insightsTwitterProfileCurationLayoutTemplate'
    });

    const ExportLayout = Dashboard.views.ExportWidgets.extend({
        childView: Dashboard.views.ExportLayout.extend({
            config: config
        })
    });

    curations.TwitterInsightsCuration = curations._BaseTwitterInsightsCuration.extend({

        widgetsView: TwitterInsightsLayout,
        exportWidgetsView: ExportLayout,

        exportTitle: 'Twitter Analytics',

        buildConfiguration: function () {
            const definitions = widgets;

            return new RivalIQ.apps.Dashboard.models.Configuration({
                props: {
                    source: RivalIQ.enums.sources.TWITTER_INSIGHTS,
                    channel: RivalIQ.enums.channels.TWITTER
                },
                definitions: definitions
            });
        }
    });
});
